// services/features/agentService.ts
import axios from "axios";
import { MAIN_API_URL } from "../config/api";
import { Agent, AgentModulePermission } from "../types/features/Agent";
import { PaginatedResponse } from "../types/core/PaginatedResponse";

export const agentService = {
  // Vérifier une invitation (public)
  async checkInvitation(token: string) {
    const response = await axios.post(`${MAIN_API_URL}/agents/invitation/check`, { token });
    return response.data;
  },

  // Accepter une invitation (frontend envoie le token Izilife)
  async acceptInvitation(invitationToken: string, izilifeToken: string) {
    const response = await axios.post(`${MAIN_API_URL}/agents/invitation/accept`, {
      token: invitationToken,
      izilife_token: izilifeToken,
    });
    return response.data;
  },

  // Liste des agents
  async getAgents(token: string, page: number = 1, perPage: number = 20): Promise<PaginatedResponse<Agent>> {
    const response = await axios.get<PaginatedResponse<Agent>>(`${MAIN_API_URL}/agents`, {
      params: { page, per_page: perPage },
      headers: { Authorization: `Bearer ${token}` },
    });

    return response.data;
  },

  // Détail d'un agent
  async getAgentById(token: string, id: string): Promise<Agent | null> {
    const response = await axios.get<Agent>(`${MAIN_API_URL}/agents/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  // Mettre à jour un agent
  async updateAgent(token: string, id: string, data: Partial<Agent>): Promise<Agent> {
    const response = await axios.put<Agent>(`${MAIN_API_URL}/agents/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },

  // Supprimer un agent
  async deleteAgent(token: string, id: string): Promise<void> {
    await axios.delete(`${MAIN_API_URL}/agents/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  // ============================================
  // ROUTES PERMISSIONS DES AGENTS
  // ============================================

  // Récupérer les permissions d'un agent
  async getAgentPermissions(token: string, agentId: string): Promise<{
    agent: { id: string; full_name: string; email: string };
    permissions: AgentModulePermission[];
  }> {
    const response = await axios.get(`${MAIN_API_URL}/agents/${agentId}/permissions`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data;
  },

  // Attribuer des permissions à un agent
  async assignPermissions(
    token: string,
    agentId: string,
    permissions: {
      module_id: string;
      endpoints?: string[];
      is_active?: boolean;
    }[]
  ): Promise<any> {
    const response = await axios.post(
      `${MAIN_API_URL}/agents/${agentId}/permissions`,
      { permissions },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  // Mettre à jour une permission
  async updatePermission(
    token: string,
    permissionId: string,
    data: { endpoints?: string[]; is_active?: boolean }
  ): Promise<any> {
    const response = await axios.put(
      `${MAIN_API_URL}/agents/permissions/${permissionId}`,
      data,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  // Supprimer une permission
  async deletePermission(token: string, permissionId: string): Promise<void> {
    await axios.delete(`${MAIN_API_URL}/agents/permissions/${permissionId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  // Récupérer les modules disponibles pour l'entreprise
  async getAvailableModules(token: string): Promise<any> {
    const response = await axios.get(`${MAIN_API_URL}/agents/available-modules`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data;
  },
};